import AppShell from "@/components/AppShell";

export default function LegalShell({ eyebrow, title, updated, children, testid }) {
  return (
    <AppShell>
      <section className="max-w-[860px] mx-auto px-5 sm:px-8 py-14 sm:py-20" data-testid={testid}>
        <div className="pnc-eyebrow mb-4">{eyebrow}</div>
        <h1 className="font-heading text-4xl sm:text-5xl font-semibold text-[#F5F5F5] tracking-tight leading-[1.05] mb-3">
          {title}
        </h1>
        {updated && (
          <div className="text-[13px] text-[#6B6B6B] mb-10">Last updated: {updated}</div>
        )}
        <div className="pnc-prose">{children}</div>
      </section>
    </AppShell>
  );
}
